export default function Footer() {
  return (
    <footer id="connect">
      <div className="container">
        <div className="footer-blob">
          <span role="img" aria-label="send">&#9993;</span>
        </div>

        <h2 className="footer-title">
          Let's build something <span className="text-primary italic">meaningful</span> together.
        </h2>

        <p className="footer-subtitle">
          Whether you want to discuss AI architecture, need a travel recommendation for Kyoto, or just want to say hi—my inbox is always open.
        </p>

        <a href="mailto:shavonharrisdev@gmail.com" className="footer-email">
          shavonharrisdev@gmail.com
        </a>

        <div className="footer-links">
          <a href="https://github.com/ShavonHarris-Dev" className="footer-link" target="_blank" rel="noopener noreferrer" aria-label="View Shavon's GitHub profile">GitHub</a>
          <a href="https://www.linkedin.com/in/shavonharris-dev/" className="footer-link" target="_blank" rel="noopener noreferrer" aria-label="View Shavon's LinkedIn profile">LinkedIn</a>
          <a href="https://dev.to/shavonharrisdev" className="footer-link" target="_blank" rel="noopener noreferrer" aria-label="Check out my musings">Dev.to</a>
        </div>

        <div className="footer-bottom">
          <p className="footer-note">Built with curiosity & care in Chicago</p>
          <div className="footer-tagline">
            <span className="footer-heart" role="img" aria-label="heart">&#10084;</span>
            <span>Stay whimsical.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
